import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { SOCIAL, CONTACT } from "../data/content";

const MessengerIcon = ({ className = "w-7 h-7" }) => (
  <svg className={className} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 2C9.03 2 2 8.58 2 17.1c0 4.49 1.98 8.37 5.2 11.04.27.22.43.54.44.89l.09 2.94a1.28 1.28 0 0 0 1.8 1.13l3.28-1.45c.27-.12.57-.14.85-.07 1.37.38 2.83.58 4.34.58 8.97 0 16-6.58 16-15.1C34 8.58 26.97 2 18 2Z"
      fill="#fff"
    />
    <path
      d="m8.39 22.06 4.7-7.46c.75-1.19 2.35-1.48 3.47-.64l3.74 2.8c.34.26.81.26 1.15 0l5.05-3.83c.67-.51 1.55.3 1.1 1.02l-4.7 7.45c-.75 1.19-2.36 1.49-3.47.64l-3.74-2.8a.96.96 0 0 0-1.15 0l-5.05 3.84c-.67.51-1.55-.3-1.1-1.02Z"
      fill="#0084FF"
    />
  </svg>
);

export default function MessengerButton() {
  const [open, setOpen] = useState(false);
  const handle = SOCIAL.messenger?.trim();
  const link = handle ? `https://m.me/${handle}` : SOCIAL.facebookUrl || "";

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, []);

  if (!link) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.9 }}
            className="relative max-w-[240px] bg-white rounded-2xl shadow-2xl ring-1 ring-slate-100 p-4 pr-8"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center text-slate-400 hover:bg-slate-100"
              aria-label="Bezárás"
            >
              <X className="w-4 h-4" />
            </button>
            <p className="text-sm font-semibold text-slate-800 leading-snug">
              Üdv! Kérdése van? Írjon nekünk <span className="text-sky-600">Messengeren</span> 👋
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <a
        data-testid="messenger-chat-button"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => setOpen(false)}
        className="group relative flex items-center justify-center w-16 h-16 rounded-full shadow-xl shadow-sky-900/20 ss-pulse"
        style={{ background: "linear-gradient(45deg,#0084FF 0%,#00C6FF 100%)" }}
        title="Chat Messengeren"
      >
        <MessengerIcon className="w-9 h-9 transition-transform group-hover:scale-110" />
      </a>
    </div>
  );
}
